import type { UseFormHandleSubmit } from 'react-hook-form';
import type { PartialDeep } from 'type-fest';
import type { ConfigOverride } from '#dn-types/host.ts';
import { mapFormToOverrides } from '#screens/hosts/form/advanced/mappers/mapFormToOverrides.ts';
import type { ConfigOverridesTransformedFormData } from '#screens/hosts/form/host-form-types.ts';

type Handler<FormData extends PartialDeep<ConfigOverridesTransformedFormData>> = UseFormHandleSubmit<FormData>;

export function makeOnSubmit<FD extends PartialDeep<ConfigOverridesTransformedFormData>>(
  handler: Handler<FD>,
  onSave: (overrides: ConfigOverride[]) => void
) {
  return (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    return handler((data) => {
      return Promise.resolve(onSave(mapFormToOverrides(data)));
    })(e);
  };
}
